import api from './api';

export const postService = {
  async getAll(postType = '') {
    const params = postType ? { post_type: postType } : {};
    const response = await api.get('/posts/', { params });
    return response.data.data || [];
  },

  async getById(id) {
    const response = await api.get(`/posts/${id}`);
    return response.data.data;
  },

  async create(formData) {
    const response = await api.post('/posts/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  },

  async update(id, formData) {
    const response = await api.put(`/posts/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  },

  async delete(id) {
    const response = await api.delete(`/posts/${id}`);
    return response.data;
  },
};
